import { useState } from 'react'

import * as style from './style.module.sass'

export const useToast = (text: string) => {
  const [toast, setToast] = useState(false)

  const show = () => {
    if (toast) {
      return
    }

    setToast(true)
    setTimeout(() => setToast(false), 2000)
  }

  return {
    show,
    Toast: (
      <div className={style.toast} data-show={toast}>
        {text}
      </div>
    ),
  }
}
